import { connect } from "react-redux";
import AuthBookingLayer from "app/pages/Auth/AuthBookingLayer/AuthBookingLayer";
import { getFallbackRedirectUrl, getPartnerBookingAuthText } from "app/reducers/partnerSelector";
import { getUUID } from "app/pages/Auth/authSelectors";

const mapStateToProps = state => {
	return {
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
		showSigninByDefault: Boolean(getUUID(state)),
		bookingAuthLandingText: getPartnerBookingAuthText(state),
		strategy: state.partner.strategy,
	};
};

export default connect(mapStateToProps)(AuthBookingLayer);
